import { DateTime } from 'luxon'
import { Link } from 'react-router-dom'
import { Label, Table } from 'semantic-ui-react'
import { Text } from '@/componentsV1/BaseComponents'
import { FinancialAccountReconciliationWithTransactions } from '@/reducers/admin/allFinancialAccountReconciliationsReducer'
import {
  FinancialAccountWithAdminInfo,
  ReconciliationOrigin,
} from '@/reducers/admin/financialAccountsReducer'
import { formatCurrencyFromCents } from '@/utils/currencyHelpers'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import StatementExtractionBadge, {
  isCompletedViaStatementExtraction,
} from './StatementExtractionBadge'

const FinancialAccountReconciliationsTableRow = ({
  userId,
  financialAccount,
  financialAccountReconciliation,
}: {
  userId: number
  financialAccount?: FinancialAccountWithAdminInfo
  financialAccountReconciliation: FinancialAccountReconciliationWithTransactions
}) => {
  const accountDisplayName = `${financialAccount?.plaidInstitutionName} (${financialAccount?.mask})`
  const {
    id,
    startingBalanceDate,
    startingBalanceInCents,
    endingBalanceDate,
    endingBalanceInCents,
    status,
    origin,
    bookkeepingReportId,
  } = financialAccountReconciliation

  return (
    <Table.Row key={id}>
      <Table.Cell>
        {bookkeepingReportId === undefined ? (
          id
        ) : (
          <Link
            to={`/admin/finances/records/${userId}/monthly-books/${bookkeepingReportId}/reconciliation/${id}`}
          >
            {id}
          </Link>
        )}
      </Table.Cell>
      <Table.Cell>
        {DateTime.fromISO(startingBalanceDate, { zone: 'utc' }).toFormat(
          DATE_FORMATS_LUXON.DISPLAY_LONG
        )}
      </Table.Cell>
      <Table.Cell>{formatCurrencyFromCents(startingBalanceInCents)}</Table.Cell>
      <Table.Cell>
        {DateTime.fromISO(endingBalanceDate, { zone: 'utc' }).toFormat(
          DATE_FORMATS_LUXON.DISPLAY_LONG
        )}
      </Table.Cell>
      <Table.Cell>{formatCurrencyFromCents(endingBalanceInCents)}</Table.Cell>
      <Table.Cell>{accountDisplayName}</Table.Cell>
      <Table.Cell>
        <Label color={status === 'complete' ? 'green' : 'red'}>{status}</Label>
        {isCompletedViaStatementExtraction(financialAccountReconciliation) ? (
          <StatementExtractionBadge className="mt-1" />
        ) : (
          <Text as="bodyXs" color="darkGray" style={{ paddingTop: 4 }}>
            {origin === ReconciliationOrigin.autoRecon
              ? 'Auto-reconciled'
              : 'Manually reconciled'}{' '}
          </Text>
        )}
      </Table.Cell>
    </Table.Row>
  )
}

export default FinancialAccountReconciliationsTableRow
